import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DexieService } from './dexieService';
import { OnlineService } from './online.service';
import { Observable, from, map } from 'rxjs';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class ParticleSizeService {

  protected readonly url = environment.coreUrl + '/particleSize/';

  constructor(private http: HttpClient) {
  }

  findAll(): Observable<any> {
        return this.http.get(this.url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
